import { NavBarComponent } from "./NavBarComponent";
import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

export function Header() {
    const [showDropdown, setShowDropdown] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const handleMouseEnter = () => setShowDropdown(true);
    const handleMouseLeave = () => setShowDropdown(false);
    const handleItemClick = (path) => {
        setShowDropdown(false);
        navigate(path);
    };
    const isActive = (path) => location.pathname === path;

    return (
        <div className="text-black pt-3.5 pb-2 w-full sticky top-0 bg-white" style={{ zIndex: 999 }}>
            <div className="flex justify-between items-center">
                <Link to="/" className="cursor-pointer">
                    <img src="/Logo.png" width="100%" className="w-40 md:w-40 lg:w-52"/>
                </Link>

                <div className="block md:hidden">
                    <NavBarComponent />
                </div>

                <div className="hidden md:block">
                    <ul className="flex items-center gap-8 font-medium text-[15.8px] relative">
                        {/* Home */}
                        <li className="group cursor-pointer" onClick={() => navigate("/")}>
                            <div className="flex flex-col items-start">
                                <span className={`transition-colors duration-300 ${isActive("/") ? "text-blue-800 font-bold" : "group-hover:text-blue-800"}`}>
                                    Home
                                </span>
                                <span className={`block h-0.5 bg-blue-800 transition-all duration-300 ${isActive("/") ? "w-[60%]" : "w-0 group-hover:w-[90%]"}`}></span>
                            </div>
                        </li>

                        {/* Services Dropdown */}
                        <li className="relative" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                            <div className="group inline-block">
                                <div className="flex flex-col items-start">
                                    <span className={`cursor-pointer transition-colors duration-300 ${["/employee-transportation", "/corporate-car", "/airport-transfer"].includes(location.pathname)
                                            ? "text-blue-800 font-bold"
                                            : "group-hover:text-blue-800"
                                        }`}>
                                        Services
                                    </span>
                                    <span className={`block h-0.5 bg-blue-800 transition-all duration-300 ${["/employee-transportation", "/corporate-car", "/airport-transfer"].includes(location.pathname)
                                            ? "w-[90%]"
                                            : "w-0 group-hover:w-[90%]"
                                        }`}></span>
                                </div>
                            </div>

                            <div className={`absolute -left-2 top-full z-50 transition-all duration-300 ease-in-out transform 
                                ${showDropdown ? 'opacity-100 scale-100 visible' : 'opacity-0 scale-95 invisible'}`}>
                                <ul className="min-w-[220px] py-2 text-sm text-gray-700 bg-white shadow-lg border mt-2 border-t-4 rounded-md border-t-blue-800">
                                    <li
                                        className={`px-4 py-2 hover:bg-gray-100 dropdown-item cursor-pointer ${isActive("/employee-transportation") ? "text-blue-800  font-semibold" : ""
                                            }`}
                                        onClick={() => handleItemClick('/employee-transportation')}
                                    >
                                        <span className="transition-colors duration-300 hover:text-blue-800">
                                            Employee Transportation
                                        </span>
                                    </li>
                                    <li
                                        className={`px-4 py-2 hover:bg-gray-100 dropdown-item cursor-pointer ${isActive("/corporate-car") ? "text-blue-800  font-semibold" : ""
                                            }`}
                                        onClick={() => handleItemClick('/corporate-car')}
                                    >
                                        <span className="transition-colors duration-300 hover:text-blue-800">
                                            Corporate Car
                                        </span>
                                    </li>
                                    <li
                                        className={`px-4 py-2 hover:bg-gray-100 dropdown-item cursor-pointer ${isActive("/airport-transfer") ? "text-blue-800  font-semibold" : ""
                                            }`}
                                        onClick={() => handleItemClick('/airport-transfer')}
                                    >
                                        <span className="transition-colors duration-300 hover:text-blue-800">
                                            Airport Transfer
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        {/* About Us */}
                        <li className="group cursor-pointer" onClick={() => navigate("/about")}>
                            <div className="flex flex-col items-start">
                                <span className={`transition-colors duration-300 ${isActive("/about") ? "text-blue-800 font-bold" : "group-hover:text-blue-800"}`}>
                                    About Us
                                </span>
                                <span className={`block h-0.5 bg-blue-800 transition-all duration-300 ${isActive("/about") ? "w-[60%]" : "w-0 group-hover:w-[90%]"}`}></span>
                            </div>
                        </li>

                        {/* Get a Quote */}
                        <li className="group cursor-pointer" onClick={() => navigate("/quote")}>
                            <div className="flex flex-col items-start">
                                <span className={`transition-colors duration-300 ${isActive("/quote") ? "text-blue-800 font-bold" : "group-hover:text-blue-800"}`}>
                                    Get a Quote
                                </span>
                                <span className={`block h-0.5 bg-blue-800 transition-all duration-300 ${isActive("/quote") ? "w-[60%]" : "w-0 group-hover:w-[90%]"}`}></span>
                            </div>
                        </li>

                        {/* Contact Us Button */}
                        <li
                            className={`py-2 px-3 rounded transition-colors duration-300 relative overflow-hidden group cursor-pointer ${isActive("/contact") ? "bg-blue-800 font-bold" : "bg-[#18496B] hover:bg-blue-800"
                                }`}
                            onClick={() => navigate("/contact")}
                        >
                            <span className="text-white relative z-10">Contact Us</span>
                            <span className="absolute bottom-0 left-1/2 w-0 h-full bg-blue-900 transition-all duration-300 group-hover:w-full group-hover:left-0 -z-0 opacity-70"></span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}
